import React from 'react';

export default function CopyIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="23"
      fill="none"
      viewBox="0 0 22 23"
    >
      <path
        stroke="#4D4D4D"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.333"
        d="M16 8.667h-6c-.737 0-1.334.597-1.334 1.333v6c0 .737.597 1.334 1.333 1.334h6c.737 0 1.334-.597 1.334-1.334v-6c0-.736-.597-1.333-1.334-1.333z"
      ></path>
      <path
        stroke="#4D4D4D"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.333"
        d="M6 12.667h-.667A1.333 1.333 0 014 11.333v-6A1.333 1.333 0 015.333 4h6a1.333 1.333 0 011.334 1.333V6"
      ></path>
    </svg>
  );
}